var React = require('react');

function CheckBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.1666 5.29688L7.99998 14.4635L3.83331 10.2969","stroke":"#2A2637","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheckBlack.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = CheckBlack;

CheckBlack.default = CheckBlack;
